import { render } from "./USHousing.vue?vue&type=template&id=2bb96deb&ts=true"
import script from "./USHousing.vue?vue&type=script&lang=ts"
export * from "./USHousing.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__